import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { RootState } from '@/store';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';

const ProfilePage: React.FC = () => {
  const { user } = useSelector((state: RootState) => state.auth);
  const navigate = useNavigate();

  console.log('🔵 ProfilePage Component Mounted!');
  console.log('🔵 Current user:', user);
  console.log('🔵 Auth state:', useSelector((state: RootState) => state.auth));

  return (
    <div>
      {/* Test Element - Should be very obvious */}
      <div style={{ 
        backgroundColor: 'red', 
        color: 'white', 
        padding: '20px', 
        fontSize: '24px',
        fontWeight: 'bold',
        marginBottom: '20px'
      }}>
        🔴 TEST: IF YOU SEE THIS, THE PAGE IS RENDERING!
      </div>

      {/* Back Button with Inline Styles */}
      <div style={{ marginBottom: '24px' }}>
        <button
          onClick={() => navigate('/dashboard')}
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            padding: '8px 16px',
            fontSize: '14px',
            fontWeight: '500',
            color: '#374151',
            backgroundColor: 'white',
            border: '2px solid #10B981',
            borderRadius: '8px',
            cursor: 'pointer'
          }}
        >
          <ArrowLeftIcon style={{ width: '20px', height: '20px', marginRight: '8px' }} />
          Back to Dashboard
        </button>
      </div>

      {/* Page Header */}
      <div style={{ marginBottom: '32px' }}>
        <h1 style={{ fontSize: '30px', fontWeight: 'bold', color: '#111827' }}>Profile</h1>
        <p style={{ marginTop: '8px', color: '#6B7280' }}>Manage your account information</p>
      </div>

      {/* Profile Content */}
      <div className="bg-white rounded-lg shadow-sm border p-6">
        {user ? (
          <div>
            <p className="text-lg font-semibold mb-4">Welcome, {user.first_name} {user.last_name}!</p>
            <div className="space-y-3">
              <div className="flex items-center">
                <span className="text-gray-600 w-32">Email:</span>
                <span className="text-gray-900 font-medium">{user.email}</span>
              </div>
              <div className="flex items-center">
                <span className="text-gray-600 w-32">User ID:</span>
                <span className="text-gray-900 font-medium">{user.id}</span>
              </div>
              <div className="flex items-center">
                <span className="text-gray-600 w-32">Role:</span>
                <span className="text-gray-900 font-medium capitalize">
                  {user.role_id === 1 ? 'Super Admin' : 
                   user.role_id === 2 ? 'Admin' : 
                   user.role_id === 3 ? 'Staff' : 'User'}
                </span>
              </div>
            </div>
          </div>
        ) : (
          <p className="text-gray-600">Loading user information...</p>
        )}
      </div>
    </div>
  );
};

export default ProfilePage;
